import type { RouteRecord } from "vite-react-ssg";
import { Root } from "@/Root";
import { AccessibilityPage } from "@/pages/AccessibilityPage";
import { HomePage } from "@/pages/HomePage";
import { KnittingPage } from "@/pages/KnittingPage";
import { PricingPage } from "@/pages/PricingPage";

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Root />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "start", element: <PricingPage /> },
      { path: "accessibility", element: <AccessibilityPage /> },
      { path: "3d-knitting", element: <KnittingPage /> },
    ],
  },
];
